/*
 * Filename: \src\Settings\Vendors\AddVendor\Addresses.js
 * Created Date: 2025-12-10
 * Author: jdkohl
 *
 * Copyright (c) 2025 Logical Developments
 */

import { useAddVendorContext } from "./AddVendorContext";
import PermissionsCommon from "../Common/Permissions";
import AddressesCommon from "../Common/Addresses";

export default function Addresses({ myAddresses }) {
  const { vendor, updateVendor } = useAddVendorContext();

  const handleAddressesChange = (newAddresses) => {
    updateVendor({
      type: 'key',
      key: 'addresses',
      value: newAddresses
    });
  };

  const handlePermissionsChange = (newPermissions) => {
    updateVendor({
      type: 'key',
      key: 'permissions',
      value: newPermissions
    });
  };

  return (
    <div className="stack">
      <PermissionsCommon
        vendor={vendor}
        onChange={handlePermissionsChange}
      />
      <AddressesCommon
        vendor={vendor}
        myAddresses={myAddresses}
        onChange={handleAddressesChange}
      />
    </div>
  );
}
